
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Rajkumar Rochemuttu kam vor über dreissig Jahren in die Schweiz und landete
  durch Zufall in der Gastronomie. Er eröffnete in der Lorraine das Okra, später
  in der Länggasse das Tulsi und das Kesar beim Forsthaus. In diesen drei
  Restaurants hat er insgesamt 480 Sitzplätze. Dass der gebürtige Tamile nicht
  auf die eigene Länderküche setzt, begründet er damit, dass die indische
  vielfältiger sei. Ein weiterer Grund ist wohl, dass indisches Essen schlicht
  bekannter ist. Während die meisten Inder in der Innenstadt Restaurants
  eröffnen, bleibt er konsequent im Quartier. «Die Leute nehmen für eine gute
  Küche auch gerne einen Weg auf sich», sagt er.
    </p>
    <p>
  Viele Gerichte sind vegan oder zumindest vegetarisch, aber dass die Gäste
  weniger Fleisch bestellen, kann Rajkumar Rochemuttu nicht bestätigen. Bis zu
  30 Mitarbeiter beschäftigt er, die immer im gleichen Lokal arbeiten. «Mit
  ihnen jongliere ich nicht, denn ich bin für Beständigkeit», sagt der
  50-Jährige. Einen grossen Vorteil, drei Lokale zu führen, sieht er beim
  Einkauf: Da Rochemuttu in allen ähnliche Gerichte auf der Karte hat, fallen
  Rabatte höher aus, je mehr er bestellt. Einen beträchtlichen Anteil an den
  Warenkosten haben die grossen Gewürzmengen. Pro Jahr verkocht Rochemuttu
  schätzungsweise rund 75 Kilogramm Masala-Curry. Umsatzzahlen gibt er nicht
  bekannt.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;